var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[_c('b-tabs',{staticClass:"h-100 d-flex flex-column",attrs:{"content-class":"overflow-y-auto"}},_vm._l((_vm.activeTypes),function(type,i){return _c('b-tab',{key:i,attrs:{"title":_vm.$t(type.label)}},[_c('HelperSection',{staticClass:"mt-3",attrs:{"sections":type.sections}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }